import React from 'react'
import {
    message,
    DatePicker,
    Select,
    Icon,
    Tag,
    Tree,
    Tooltip,
    Button,
    Spin,
    Modal,
} from 'antd'
import moment from 'moment'
import CloudFlyerAPI from '../../api/CloudFlyerAPI'

const { TreeNode } = Tree

export default class FinanceHeader extends React.Component {
    constructor(props) {
        super(props)

        this.state = { logsModalVisible: false }

        this.setLogsVisibility = this.setLogsVisibility.bind(this)
    }

    setLogsVisibility(visible) {
        this.setState({ logsModalVisible: visible })
    }

    render() {
        const {
            has_write_perm,
            toggle_settings,
            open_alerts,
            history,
        } = this.props
        const { logsModalVisible } = this.state
        return (
            <div className="table-header">
                <div>
                    <span className={'title'}>
                        Actual vs. Budgeted Spending
                    </span>
                </div>

                <div className="table-actions">
                    {has_write_perm && [
                        <Button
                            key="bell"
                            icon="bell"
                            onClick={open_alerts}
                            type="primary">
                            <span>Notifications</span>
                        </Button>,

                        <Button
                            type="primary"
                            key="setting"
                            icon="setting"
                            onClick={() => toggle_settings()}>
                            <span>Set Preferences</span>
                        </Button>,

                        <Button
                            type="primary"
                            key="logs"
                            icon="bars"
                            onClick={() => history.push('/logs')}>
                            <span>Logs</span>
                        </Button>,
                    ]}
                </div>
            </div>
        )
    }
}

function renderChangeEdited(propertyName, oldValue, newValue) {
    return (
        <TreeNode
            className="change"
            title={
                <div>
                    <span className="property">{propertyName}</span>
                    <span> : </span>
                    <span className="old-value">{oldValue}</span>
                    <span> </span>
                    <Icon type="swap-right" />
                    <span> </span>
                    <span className="new-value">{newValue}</span>
                </div>
            }
        />
    )
}

function renderChangeAdded(propertyName, value) {
    return (
        <TreeNode
            className="change"
            title={
                <div>
                    <span className="property">{propertyName}</span>
                    <span> : </span>
                    <span className="new-value">{value}</span>
                </div>
            }
        />
    )
}

function renderChangeDeleted({ propertyName, value }) {
    return (
        <TreeNode
            className="change"
            title={
                <div>
                    <span className="property">{propertyName}</span>
                    <span>:</span>
                    <span className="old-value">{value}</span>
                </div>
            }
        />
    )
}

function renderOperation(operationType, userName, createdOn, changesArray) {
    const createdOnFormated = moment(createdOn).format('MMM Qo YYYY, h:mm:ss a')
    return (
        <TreeNode
            className="operation"
            title={
                <span>
                    <Tag
                        color={
                            operationType === 'Added'
                                ? 'green'
                                : operationType === 'Deleted'
                                ? 'red'
                                : 'blue'
                        }>
                        {operationType}
                    </Tag>
                    <span>by </span>
                    <span className="author">{userName}</span>
                    <span> at </span>
                    <span className="created-on">{createdOnFormated}</span>
                </span>
            }
            key={`${operationType}_${userName}_${createdOn}`}>
            {changesArray.map(ch => {
                if (operationType === 'Modified')
                    return renderChangeEdited(ch.property, ch.initial, ch.value)
                else if (operationType === 'Added')
                    return renderChangeAdded(ch.property, ch.value)
                else if (operationType === 'Deleted')
                    return renderChangeDeleted(ch.property, ch.value)
            })}
        </TreeNode>
    )
}

function renderResource(resourceName, operationsArray) {
    return (
        <TreeNode
            className="resource"
            title={<span className="name">{resourceName}</span>}
            key={resourceName}>
            {operationsArray.map(op =>
                renderOperation(op.type, op.author, op.created_on, op.changes)
            )}
        </TreeNode>
    )
}

function renderEntity(entityName, resourcesObj) {
    return (
        <TreeNode
            className="entity"
            title={<span className="name">{entityName}</span>}>
            {Object.keys(resourcesObj).map(k =>
                renderResource(k, resourcesObj[k])
            )}
        </TreeNode>
    )
}

class LogsFilter extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            form: {
                entities: [],
                users: [],
                fromDate: '',
                toDate: '',
            },
            selected: {
                entities: [],
                users: [],
                fromDate: '',
                toDate: '',
            },
        }

        this.handleChange = this.handleChange.bind(this)
        this.filter = this.filter.bind(this)
    }

    componentDidMount() {
        this.setState({ loading: true })
        CloudFlyerAPI.finance
            .filters()
            .then(({ data }) => {
                this.setState({
                    loading: false,
                    form: {
                        ...this.state.form,
                        entities: [...data.entities],
                        users: [...data.users],
                    },
                })
            })
            .catch(res => {
                this.setState({ loading: false })
                console.log('Could not load filters: ', res)
            })
    }

    handleChange(target, newValue) {
        this.setState({
            selected: {
                ...this.state.selected,
                [target]: newValue,
            },
        })
    }

    filter() {
        const { fromDate, toDate, entities, users } = this.state.selected
        const { onStartFilter, onFilter } = this.props
        onStartFilter()
        CloudFlyerAPI.finance
            .audits(fromDate, toDate, entities, users)
            .then(({ data }) => onFilter(data))
            .catch(res => {
                console.log('Could not filter : ', res)
                message.error('Error while trying to filter logs.')
            })
    }

    render() {
        const { loading } = this.state
        const { entities, users, fromDate, toDate } = this.state.form
        return (
            <Spin spinning={loading}>
                <div className="logs-filter">
                    <Select
                        mode="multiple"
                        placeholder="Entities"
                        onChange={newValue =>
                            this.handleChange('entities', newValue)
                        }>
                        {entities.map(entity => (
                            <Select.Option value={entity.value}>
                                {entity.key}
                            </Select.Option>
                        ))}
                    </Select>
                    <Select
                        mode="multiple"
                        placeholder="Users"
                        onChange={newValue =>
                            this.handleChange('users', newValue)
                        }>
                        {users.map(user => (
                            <Select.Option value={user.value}>
                                {user.key}
                            </Select.Option>
                        ))}
                    </Select>
                    <DatePicker
                        onChange={(momentDate, dateString) =>
                            this.handleChange(
                                'fromDate',
                                momentDate.toISOString()
                            )
                        }
                        placeholder="From"
                    />
                    <DatePicker
                        onChange={(momentDate, dateString) =>
                            this.handleChange(
                                'toDate',
                                momentDate.toISOString()
                            )
                        }
                        placeholder="To"
                    />
                    <Button
                        className="filter-btn"
                        type="primary"
                        onClick={this.filter}>
                        Filter
                    </Button>
                </div>
            </Spin>
        )
    }
}

class LogsView extends React.Component {
    constructor(props) {
        super(props)

        this.state = { loading: false, data: {} }
        this.handleFilter = this.handleFilter.bind(this)
        this.handleStartFilter = this.handleStartFilter.bind(this)
    }

    handleFilter(data) {
        this.setState({ loading: false, data })
    }

    handleStartFilter() {
        this.setState({ loading: true })
    }

    isObjEmpty(obj) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) return false
        }
        return true
    }

    render() {
        const { visible, onCancel } = this.props
        const { loading, data } = this.state

        return (
            <Modal
                className="logs-modal"
                visible={visible}
                onCancel={onCancel}
                cancelText="Close"
                okButtonProps={{ style: { display: 'none' } }}>
                <Spin spinning={loading}>
                    <div>
                        <h2 className="logs-header">
                            <Icon type="profile" /> Logs
                        </h2>
                        <LogsFilter
                            onStartFilter={this.handleStartFilter}
                            onFilter={this.handleFilter}
                        />
                    </div>
                    <div className="logs-container">
                        {!this.isObjEmpty(data) ? (
                            <Tree className="logs-tree">
                                {Object.keys(data).map(k =>
                                    renderEntity(k, data[k])
                                )}
                            </Tree>
                        ) : (
                            <div className="empty-state">No Logs To View</div>
                        )}
                    </div>
                </Spin>
            </Modal>
        )
    }
}
